<template>
  <div class="leaderboard-canvas" v-if="showme">
    <div class="looker-row">
      <div class="cb-title">
        Cell Board
        <img class="looker" @click="$emit('find', { player: getMe() })" src="../img/looker.svg" alt="Find myself" :title="`Find Myself`">
        <span class="showinmobile" @click="showme = false">X</span>
      </div>
    </div>
    <div class="rank-list">
      <div class="bg-row" :class="{ me: myUserID === leader.userID }" :key="leader.userID" v-for="(leader, idx) in leaderboard">
        <div>#{{idx + 1}} <div class="ball" alt="Find User" :title="`find ${leader.displayName}'`" @click="$emit('find', { player: leader.player })" :style="{ backgroundColor: leader.color }"></div> <span class="name"> {{ leader.displayName }} </span> {{ leader.count }} {{ leader.count > 1 ? 'Cells' : 'Cell' }}</div>
      </div>
    </div>
    <div v-if="myStats">
      <div>
        My Correct Count: {{ myStats.correctCount }}
      </div>
      <div>
        My Incorrect Count: {{ myStats.attemptCount - myStats.correctCount }}
      </div>
      <div>
        My Total Attempt Count: {{ myStats.attemptCount }}
      </div>
    </div>
    <!-- <CloseBtn @overlay="(v) => { $emit('overlay', v) }"></CloseBtn> -->
  </div>
  <div class="leaderboard-canvas" v-else>
    <div class="cb-title samller">
      <span @click="showme = true">
        Open Cell Board
      </span>
    </div>
  </div>
</template>

<script>
import * as sAPI from '../api/strapi.js'
export default {
  props: {
    activeCells: {},
    players: {}
  },
  data () {
    return {
      myStats: false,
      myUserID: sAPI.LS.UserID,
      showme: window.innerWidth > 600,
      leaderboard: false
    }
  },
  watch: {
    activeCells () {
      this.loadScores()
    },
    players: {
      deep: true,
      handler () {
        this.loadScores()
      }
    }
  },
  mounted () {
    this.loadScores()
  },
  methods: {
    getMe () {
      return this.players.find(e => e.userID === this.myUserID)
    },
    loadStats () {

    },
    loadScores () {
      this.leaderboard = this.players.reduce((c, e, i) => {
        let list = this.activeCells.filter(a => a.uid === e.userID) || []

        c.push({
          userID: e.userID,
          player: e,
          color: e.color,
          displayName: e.displayName || 'Anonymous User',
          array: list,
          count: list.length
        })

        // if (list.length === 0) {
        //   let core = e.gameInfo.cellCore
        //   let gameID = e.gameID
        //   let numID = core.numID
        //   Game.GFDB.ref(`/players/${gameID}/activeCells/${numID}`).set(core)
        // }
        return c
      }, [])

      this.leaderboard = this.leaderboard.sort((a, b) => {
        if (a.count > b.count) {
          return -1
        } else if (a.count < b.count) {
          return 1
        } else {
          return 0
        }
      })
    }
  }
}
</script>

<style>

</style>
